import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3284qfhduv: FaireBrandEntity = {
  token: "b_3284qfhduv",
  type: "brand",
  name: "Whiskey & Lace Outfitters /The Longhorn Hippie Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/bc0204bfad70494696418a969e43e4c745ec6bc943f6c7f5f40e9ea75bb7a812.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a1441a4ca0415a1478c52fa6c3ca52d69c360389661488ff45e188e9955f4ab2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bc0204bfad70494696418a969e43e4c745ec6bc943f6c7f5f40e9ea75bb7a812.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a1441a4ca0415a1478c52fa6c3ca52d69c360389661488ff45e188e9955f4ab2.png",
  location: "REPUBLIC, MO, USA",
  minimumOrderDollars: 150,
  rating: 3.8,
  reviewCount: 316,
  isInsider: true,
  description:
    "Whiskey & Lace Outfitters is a family owned business located in the Heart Of The Ozarks for over 12 years. We specialize  in top notch high quality professional graphic tee’s, western wear & accessories. We pride ourselves in bringing small & large businesses wholesale exceptional quality boutique clothing & graphic tee's at prices everyone can afford and best of all made right here in the USA. We try and bring you new designs each and every week and most of the time each and every day so add us to your favorites so you can check back with us often. Thank you all for supporting our business. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:48.775Z",
    importedBy: "entity-db-cli",
  },
};
